module.exports = __webpack_public_path__ + "static/media/muttonbiryani.e0714410.jpg";